import * as React from 'react';
import AddressSelection from '../../containers/AddressSelection';
import { RegistrationDeskEventHandler } from '../../state-machine';

interface Props {
  onAdressSelected: RegistrationDeskEventHandler<'proceed.saveRegistrationType'>
}

const HomeScreen: React.FC<Props> = (props) => {
  const { onAdressSelected } = props;

  return (
    <AddressSelection
      onAddressSelected={({
        eamData,
        registrationType,
        usageM3,
      }) => {
        onAdressSelected({
          eamData,
          registrationType,
          usageM3,
        });
      }}
    />
  );
};

export default HomeScreen;
